import React, { useState, forwardRef, useEffect, useRef } from 'react';
import { ReactComponent as PauseComp } from '../../../assets/icons/pauserecord.svg'; //暂停
import { ReactComponent as RecordingComp } from '../../../assets/icons/recording.svg'; //录制中
import { ReactComponent as StopRecordComp } from '../../../assets/icons/stoprecord.svg'; //停止录制
import { ReactComponent as MicrophoneBrandComp } from '../../../assets/icons/microphone-brand.svg'; //麦克风图标黑色正常
import { ReactComponent as MicrophoneDisabledComp } from '../../../assets/icons/microphone-disabled.svg'; //麦克风disabled
import { ReactComponent as MicrophoneUnSelect } from '../../../assets/icons/unselect-mic.svg';
import { ReactComponent as VolumeBrandComp } from '../../../assets/icons/volume-brand.svg'; //蓝色喇叭图标，说明开启
import { ReactComponent as VolumeDisabledComp } from '../../../assets/icons/volume-disabled.svg'; //喇叭disabled图标
import './index.less';
import { useTranslation } from 'react-i18next';
import DeskModal from '../components/deskModal/index';
import sendGaEvent from '@/ga';
import { Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import Utils from '../../../utils';
const Recording = forwardRef((props, videoRef) => {
  const {
    isPauseVideo, ////是否录制的状态
    controlRecord,
    sysAudio, //初始化选项
    Microphone, //初始化选项
    stopRecord,
    isClock, //是否结束倒计时
    setIsStop,
    setVideoTime, //获取视频时长
    showBanner,
    openScreenPurchase, //打开订阅弹框
  } = props;
  const { t } = useTranslation('screenRecorder');
  const [recordingTime, setRecordingTime] = useState(0);
  const [isOpenDesk, setIsOpenDesk] = useState(false);
  const reducerData = useSelector((state) => state.common);
  const [isMic, setIsMic] = useState(Microphone); //这里是确定是否屏蔽麦克风的选项

  let timer = useRef(null); //定时器

  const upgradeMore = () => {
    /* 
    学聪，录屏这两个地方触发的购买跳转reason参数好像不对
    这两个地方应该跳转的reason=0
    [吃瓜]第一次的点击的时候是上报的reason=0 ，但是如果之前在其他地方触发过购物车链接跳转，就会带上之前购物车链接跳转的参数了
    */
    window.sessionStorage.reason = '4';

    sendGaEvent({
      category: 'Upgrade',
      action: 'ScreenRecorder_SubscribePromptShow',
      label: `10minLimitTip_${Utils.systemCheck()}`,
    });
    openScreenPurchase(2);
  };

  useEffect(() => {
    if (isClock) {
      timer.current = setInterval(() => {
        setRecordingTime((recordingTime) => {
          if (showBanner) {
            setVideoTime(recordingTime + 1);
          }
          return recordingTime + 1;
        });
      }, 1000);
    } else {
      clearInterval(timer.current);
    }
    return () => {
      clearInterval(timer.current);
    };
  }, [isClock, showBanner]);

  const closeModal = () => {
    setIsOpenDesk(false);
  };

  const stopped = () => {
    clearInterval(timer.current);
    console.log('按钮触发执行');
    sendGaEvent({
      category: 'record',
      action: 'end_record',
      label: recordingTime + 's',
    });
    sendGaEvent({
      category: 'ProcessStart',
      action: '06SR_ProcessStart',
      label: 'Null',
    });
    setVideoTime(recordingTime);
    setIsStop(true);
    stopRecord();
    sendGaEvent({
      category: 'ProcessSuccess',
      action: '06SR_ProcessSuccess',
      label: 'Null',
    });
  };
  const controlMic = () => {
    if (!window.mic) return;
    if (isMic) {
      window.mic.getAudioTracks().forEach((track) => (track.enabled = false));
      setIsMic(false);
    } else {
      window.mic.getAudioTracks().forEach((track) => (track.enabled = true));
      setIsMic(true);
    }
  };
  return (
    <div className='recordingContainer'>
      <DeskModal
        type='screen'
        isOpenDesk={isOpenDesk}
        closeModal={closeModal}
      />
      <div className='videoContainer'>
        <video autoPlay muted className='recordVideo' ref={videoRef}></video>
      </div>
      <div className='videoControl'>
        <div className='videoControlBox'>
          {isPauseVideo ? (
            <Tooltip title={t('Pause')}>
              <RecordingComp
                className='controlIcon'
                onClick={() => controlRecord()}
                style={{
                  cursor: 'pointer',
                  zIndex: 10,
                  width: 20,
                  height: '100%',
                }}
              />
            </Tooltip>
          ) : (
            <Tooltip title={t('Continue')}>
              <PauseComp
                style={{
                  cursor: 'pointer',
                  zIndex: 10,
                  width: 20,
                }}
                onClick={() => controlRecord()}
              />
            </Tooltip>
          )}
        </div>
        <div className='timeBox'>
          <span
            className={
              recordingTime > 600 && !Utils.computedSubscribe(reducerData)
                ? 'exceedTime'
                : ''
            }
          >
            {Utils.formatSeconds(recordingTime)}{' '}
          </span>

          <span className='limitTime'>
            {!Utils.computedSubscribe(reducerData) ? ' / 10:00' : ''}{' '}
          </span>
        </div>
        <div className='divider' />
        {/**分割线 */}
        <div className='noControlBox' style={{ cursor: 'default' }}>
          {sysAudio ? (
            <VolumeBrandComp style={{ zIndex: 10 }} />
          ) : (
            <VolumeDisabledComp style={{ zIndex: 10 }} />
          )}
        </div>
        <div onClick={() => controlMic()} className='videoControlBox'>
          {Microphone ? (
            isMic ? (
              <MicrophoneBrandComp />
            ) : (
              <MicrophoneUnSelect />
            )
          ) : (
            <MicrophoneDisabledComp />
          )}
        </div>
        <div className='divider' /> {/**分割线 */}
        <div className='videoControlBox'>
          <Tooltip title={t('Stop')}>
            <StopRecordComp className='controlIcon' onClick={() => stopped()} />
          </Tooltip>
        </div>
      </div>
      {recordingTime >= 600 && !Utils.computedSubscribe(reducerData) ? (
        <div className='recordOptions'>
          <div>
            {t('TenMinUp')}
            <span className='highLight' onClick={() => upgradeMore()}>
              {' '}
              {t('UpgradeMore')}
            </span>
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
});

export default Recording;
